import React, {useEffect, useState} from "react";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {observer, useObserver} from "mobx-react-lite";
import {useGoogleAnalytics} from "../hooks/useGoogleAnalytics";
import {AuthChecker} from "../_core/AuthChecker";
import {Theme} from "../components/themes/Theme";
import {DashboardPage} from "../components/dashboard/DashboardPage";
import {LoginPage} from "../components/login/LoginPage";
import {ProfilePage} from "../components/profile/ProfilePage";
import {UserPage} from "../components/user/UserPage";
import {NewUser} from "../components/user/newUser/NewUser";
import {CompanyPage} from "../components/company/CompanyPage";
import {CompanyDetail} from "../components/company/companyDetail/CompanyDetail";
import {UpdateSubCompany} from "../components/company/updateSubCompany/UpdateSubCompany";
import {AddSubCompany} from "../components/company/addSubCompany/AddSubCompany";
import {NewCompany} from "../components/company/newCompany/NewCompany";
import {OnboardingCompanyDetail} from "../components/company/onboardingCompanyDetail/OnboardingCompanyDetail";
import {UserDetail} from "../components/user/userDetail/UserDetail";
import {CourierPage} from "../components/courier/CourierPage";
import {MultipleDedication} from "../components/courier/MultipleDedication/MultipleDedication";
import {CourierDetail} from "../components/courier/courierDetail/CourierDetail";
import {NewCourier} from "../components/courier/newCourier/NewCourier";
import {OrderDetail} from "../components/order/orderDetail/OrderDetail";
import {OrderPage} from "../components/order/OrderPage";
import {NewRequest} from "../components/newRequest/NewRequest";
import {ReportsPage} from "../components/reports/ReportsPage";
import MetabaseReportsPage from "../components/reports/metabaseReports/MetabaseReportsPage";
import {metabaseReportRoles} from "./routes";
import {CourierDedication} from "../components/company/courierDedication/CourierDedication";
import {MergeOptions} from "../components/company/companyDetailOptions/MergeOptions";
import {QueueOptions} from "../components/company/companyDetailOptions/QueueOptions";
import ShiftOptions from "../components/company/companyDetailOptions/ShiftOptions/ShiftOptions";
import {ProofOfDelivery} from "../components/company/companyDetailOptions/ProofOfDelivery";
import {SmsTrackingOptions} from "../components/company/companyDetailOptions/SmsTrackingOptions";
import {AppConfigPage} from "../components/appConfig/AppConfigPage";
import {Statistics} from "../components/statistics/StatisticsPage";
import {DynamicPriceOptions} from "../components/company/companyDetailOptions/DynamicPriceOptions";
import {DeliveryVerificationOptions} from "../components/company/companyDetailOptions/DeliveryVerificationOptions";
// import {Heatmap} from "../components/heatMap/HeatMap";
import {SlotOrderOptions} from "../components/company/companyDetailOptions/SlotOrderOptions";
import {CourierStatisticsReportPage} from "../components/reports/courierStatisticsReport/CourierStatisticsReportPage";
import {OrderReportPage} from "../components/reports/orderReport/OrderReportPage";
import {LocationCheckOptions} from "../components/company/companyDetailOptions/LocationCheckOptions";
import BarcodeOptions from "../components/company/companyDetailOptions/BarcodeOptions/BarcodeOptions";
import ShiftManagement from "../components/shiftManagement/ShiftManagement";
// import ShiftSuggestion from "../components/shiftSuggestion/ShiftSuggestion";
import ShiftScore from "../components/shiftScore/ShiftScore";
import {Objections} from "../components/shiftScore/objections/Objections";
import CutOffOptions from "../components/company/companyDetailOptions/CutOffOptions/CutOffOptions";
import {CourierShiftDetail} from "../components/courier/courierShiftDetail/courierShiftDetail";
import ShiftCompliance from "../components/shiftCompliance/ShiftCompliance";
import {ShiftSuggestionOptions} from "../components/company/companyDetailOptions/ShiftSuggestionOptions";
import {DayOff} from "../components/dayOff/DayOff";
import {message} from "antd";
import stores from "../store/stores";
import {PaymentManagement} from "../components/paymentManagement/PaymentManagement";
import AuthorizationManagement from "../components/user/AuthorizationManagement";
import OperationOrganization from "../components/operationOrganization/OperationOrganization";
import {UserAuthorization} from "../components/user/userAuthorization/UserAuthorization";
import NewPool from "../components/pools/newPool/NewPool";
import PoolDetail from "../components/pools/poolDetail/PoolDetail";
import EditPool from "../components/pools/editPool/EditPool";
import Pools from "../components/pools/pools/Pools";
import {CreateDeliveryRequest} from "../components/createDeliveryRequest/CreateDeliveryRequest";
import {LiveOperationPage} from "../components/liveOperation/LiveOperationPage";
import {SubCompanyPaymentContractList} from "../components/company/subCompanyDetail/subCompanyPaymentContracts/SubCompanyPaymentContractList";
import {CreditLogTable} from "../components/credits/CreditLogTable";
import {SubCompanyInvoiceManagement} from "../components/subCompanyInvoices/SubCompanyInvoiceManagement";
import {ObjectionPage} from "../components/company/objection/ObjectionPage";
import {CariList} from "../components/cari/CariList";
import CustomerHomePage from "../components/customer/customerHomePage/CustomerHomePage";
import CustomerOrdersPage from "../components/customer/customerOrdersPage/CustomerOrdersPage";
import CustomerAccountingPage from "../components/customer/customerAccountingPage/CustomerAccountingPage";
import CustomerProfilePage from "../components/customer/customerProfilePage/CustomerProfilePage";
import CustomerManualDeliveryPage from "../components/customer/customerManualDeliveryPage/CustomerManualDeliveryPage";
import CustomerCourierDailyOperationsPage from "../components/customer/customerCourierDailyOperationsPage/CustomerCourierDailyOperationsPage";
import CustomerOrderDetailPage from "../components/customer/customerOrderDetailPage/CustomerOrderDetailPage";
import {CustomerContractPage} from "../components/customer/customerContractPage/CustomerContractPage";
import {FalseCompanyRecords} from "../components/company/falseCompanyRecords/FalseCompanyRecords";
import ShiftManagementSnapshot from "../components/shiftManagementSnapshot/ShiftManagementSnapshot";
import DailyPoolForecasts from "../components/pools/dailyPoolForecasts/DailyPoolForecasts";
import DailyPoolSlots from "../components/pools/dailyPoolSlots/DailyPoolSlots";
import PoolShiftManagement from "../components/pools/poolShiftManagement/PoolShiftManagement";
import PoolCourierShifts from "../components/pools/poolCourierShifts/PoolCourierShifts";
import PoolCancelRequests from "../components/pools/poolCancelRequests/PoolCancelRequests";
import EditPoolUsers from "../components/pools/editPoolUsers/EditPoolUsers";
import {CariListDetail} from "../components/cari/CariListDetail/CariListDetail";
import {SubcompanyPage} from "../components/subcompany/SubcompanyPage";
import {SubCompanyDetailWithTab} from "../components/company/subCompanyDetailWithTab/SubCompanyDetailWithTab";
import PoolIntensities from "../components/pools/poolIntensities/PoolIntensities";
import PoolIntensityCallbacks from "../components/pools/poolIntensityCallbacks/PoolIntensityCallbacks";
import Payments from "../components/payments/Payments";
import {AvailableCouriers} from "../components/availableCouriers/AvailableCouriers";
import {NewPasswordRedesign} from "../components/newPassword/NewPasswordRedesign";
// import TransferPage from "../components/transfer/TransferPage";
// import PlanningDraft from "../components/transfer/planningDraft/PlanningDraft";
// import CalculatedTransfer from "../components/transfer/calculatedTransfer/CalculatedTransfer";
// import TransferGrouping from "../components/transfer/transferGrouping/TransferGrouping";
// import {ActiveTransfers} from "../components/transfer/activeTransfers/ActiveTransfers";
// import TransferActivities from "../components/transfer/transferActivities/TransferActivities";
import {CODPaymentOptions} from "../components/company/companyDetailOptions/CODPaymentOptions";
import {ReadyOrderNotification} from "../components/company/companyDetailOptions/readyOrderNotification";
import {EditSupplierPage, SupplierPage} from "../components/supplierPage";
import {IntegratorPage} from "../components/integrationPage";
import PoolPaymentContracts from "../components/pools/poolPaymentContracts/poolPaymentContract";
import {BackofficeCashOnDeliveryPage} from "../components/cashOnDelivery/backoffice/BackofficeCashOnDeliveryPage";
import CustomerCashOnDeliveryPage from "../components/customer/customerCashOnDeliveryPage/CustomerCashOnDeliveryPage";
import {ContractTemplateManagement} from "../components/contract/contractTemplateManagement";
// import ShipmentActivitiesDetail from "../components/transfer/shipmentActivitiesDetail/ShipmentActivitiesDetail";
import {CourierTerminalListPage} from "../components/cashOnDelivery/backoffice/courierTerminals/CourierTerminalListPage";
// import UndeliveredShipments from "../components/transfer/undeliveredShipments/UndeliveredShipments";
import {PoolCourierBonusCampaigns} from "../components/pools/poolCourierBonusCampaigns/PoolCourierBonusCampaigns";
// import TransferCenterList from "../components/transfer/transferCenterList/TransferCenterList";
// import NewTransferCenter from "../components/transfer/newTransferCenter/NewTransferCenter";
// import TransferDashboard from "../components/transfer/transferDashboard/TransferDashboard";
import PoolMergeOptions from "../components/pools/poolMergeOptions/poolMergeOptions";
import {CourierWalletListPage} from "../components/wallet/couriers/courierWalletListPage/CourierWalletListPage";
import {InactiveCourierWalletListPage} from "../components/wallet/couriers/inactiveCourierWalletListPage/InactiveCourierWalletListPage";
import PoolSupporter from "../components/pools/components/poolSupporter/PoolSupporter";
import {BackOfficeCODPastPeriodsPage} from "../components/cashOnDelivery/pastPeriods/backOfficeCODPastPeriodsPage/BackOfficeCODPastPeriodsPage";
import {MerchantCODPastPeriodsPage} from "../components/cashOnDelivery/pastPeriods/merchantCODPastPeriodsPage/MerchantCODPastPeriodsPage";
import {BackofficePaymentSummaryPage} from "../components/cashOnDelivery/summary/BackofficePaymentSummaryPage";
import {WalletCourierFinancialUploads} from "../components/wallet/WalletCourierFinancialUploads";
import {AdjustmentTypesPage} from "../components/adjustments/adjustmentTypes/AdjustmentTypesPage";
import {TicketTypesPage} from "../components/tickets/ticketTypes/TicketTypesPage";
import {TicketManagementPage} from "../components/tickets/management/TicketManagementPage";
import {ApplicationsPage} from "../components/applications/ApplicationsPage";
import {ApplicationDetailPage} from "../components/applications/detail/ApplicationDetailPage";
import {CustomerTicketsPage} from "components/tickets/customer/CustomerTicketsPage";
import {TICKET_BACKOFFICE_ROLES, USER_TICKET_VIEWER_ROLES} from "../constants/ticket";
import {APPLICATION_ROLES, APPLICATION_TYPES} from "../constants/application";
import {CourierAdjustmentsPage} from "../components/adjustments/courierAdjustments/CourierAdjustmentsPage";
import {SubcompanyCodPaymentListPage} from "../pages/codPayment/SubcompanyCodPaymentListPage";
import {SubCompanyPricingListPage} from "components/subCompanyPricing/SubCompanyPricingListPage";
import {EditIntegratorPage} from "components/integrationPage/EditIntegrator/EditIntegratorPage";
import {BackofficeMatchableInvoicesPage} from "../components/cashOnDelivery/matchableInvoices/BackofficeMatchableInvoicesPage";
import {CustomerHeatMap} from "components/customer/customerHeatMap/CustomerHeatMap";
import CustomerStatisticsPage from "components/customer/customerStatisticsPage/CustomerStatisticsPage";
import {CustomerIntegrationsPage} from "components/customer/customerIntegrationsPage/CustomerIntegrationsPage";
import CustomerReportsPage from "components/customer/customerReportsPage/CustomerReportsPage";
import CourierRequestsPage from "components/courierRequests/courierRequestsPage/CourierRequestsPage";
// import CourierSupportRequestsPage from "components/courierSupportRequestsPage/CourierSupportRequestsPage";
import CustomerRequestsPage from "components/customer/customerRequestsPage/CustomerRequestsPage";
import CustomerShiftsPage from "components/customer/customerShiftsPage/CustomerShiftsPage";
import Equipments from "../components/equipments/equipments/Equipments";
import EquipmentsTypes from "../components/equipments/equipmentsTypes/EquipmentsTypes";
import {CourierEquipments} from "components/equipments/courierEquipments/CourierEquipments";
import EquipmentRequests from "../components/equipments/equipmentRequests/EquipmentRequests";
import {PaymentsPage} from "components/adjustments/paymentsPage/PaymentsPage";
import {PAYMENTS_PERMISSION_KEYS} from "../constants/payments";

const GoogleAnalyticsWrapper = () => {
    useGoogleAnalytics();
    return null;
};

const Routes = observer(() => {
    const [messageApi, contextHolder] = message.useMessage();
    const [msg, setMsg] = useState("");

    const success = id => {
        messageApi.open({
            type: "success",
            content: id
        });
    };

    document.addEventListener("click", event => {
        if (
            (event.ctrlKey || event.metaKey) &&
            event.target.closest("tr") &&
            stores.meStore.checkRole("isAdmin")
        ) {
            const row = event.target.closest("tr");
            const tempInput = document.createElement("input");
            tempInput.value = row.getAttribute("data-row-key");
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);
            if (row.hasAttribute("data-row-key")) {
                setMsg(row.getAttribute("data-row-key"));
            }
        }
    });

    useEffect(() => {
        if (msg !== "") {
            success(msg);
        }
    }, [msg]);
    return useObserver(() => (
        <BrowserRouter basename={"/panel"}>
            {contextHolder}
            <GoogleAnalyticsWrapper />
            <Theme>
                <Switch>
                    <Route exact path="/login" render={props => <LoginPage {...props} />} />
                    <Route
                        exact
                        path="/map"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "hr",
                                    "hrEmployment",
                                    "ik",
                                    "agencyIk",
                                    "seller",
                                    "operationSupport",
                                    "oUser",
                                    "sOperation",
                                    "sChef",
                                    "fieldManager",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "marketing"
                                ]}
                                RenderComponent={DashboardPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/anlik-operasyon"
                        render={props => (
                            <AuthChecker
                                roles={["superadmin", "admin", "bm", "sy", "agency"]}
                                RenderComponent={LiveOperationPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/onboardingCompany"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "fieldManager"
                                ]}
                                RenderComponent={OnboardingCompanyDetail}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/false-records"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "sy",
                                    "fieldManager",
                                    "data",
                                    "software"
                                ]}
                                RenderComponent={FalseCompanyRecords}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/new"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "oUser",
                                    "bm",
                                    "sy",
                                    "seller"
                                ]}
                                RenderComponent={NewCompany}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/edit/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={NewCompany}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "seller"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/add-sub-company/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={AddSubCompany}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "oUser",
                                    "bm",
                                    "sy",
                                    "seller"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/sub-company/:subCompanyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={SubCompanyDetailWithTab}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data",
                                    "seller",
                                    "sales"
                                ]}
                                subCompanyId={props.match.params.subCompanyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/sub-company/payment-contract/:subCompanyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={SubCompanyPaymentContractList}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data",
                                    "sales"
                                ]}
                                subCompanyId={props.match.params.subCompanyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/suppliers/:companyId"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport"]}
                                RenderComponent={SupplierPage}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/integrators"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "cUser"
                                ]}
                                RenderComponent={IntegratorPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/update-sub-company/:subCompanyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={UpdateSubCompany}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy"
                                ]}
                                subCompanyId={props.match.params.subCompanyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/dedication/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={CourierDedication}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/merge-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={MergeOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/queue-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={QueueOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/shift-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={ShiftOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/proof-of-delivery/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={ProofOfDelivery}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/sms-tracking-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={SmsTrackingOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/cod-payment-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={CODPaymentOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/ready-order-notification-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={ReadyOrderNotification}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/delivery-verification-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={DeliveryVerificationOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/delivery-slot-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={SlotOrderOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/dynamic-price-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={DynamicPriceOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/location-check-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={LocationCheckOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/shift-suggestion-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={ShiftSuggestionOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/barcode-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={BarcodeOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/cut-off/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={CutOffOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/:companyId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "sOperation",
                                    "sChef",
                                    "fieldManager",
                                    "data",
                                    "software",
                                    "seller",
                                    "sales"
                                ]}
                                RenderComponent={CompanyDetail}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "sOperation",
                                    "sChef",
                                    "fieldManager",
                                    "data",
                                    "software",
                                    "seller",
                                    "sales"
                                ]}
                                RenderComponent={CompanyPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/subcompanies/pricing-list"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "sales", "agency"]}
                                RenderComponent={SubCompanyPricingListPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/subcompanies"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "fieldManager",
                                    "data",
                                    "software",
                                    "sales"
                                ]}
                                RenderComponent={SubcompanyPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/couriers/shiftdetail"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin"]}
                                RenderComponent={CourierShiftDetail}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/couriers/multiple-dedication"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "hr",
                                    "software",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy"
                                ]}
                                RenderComponent={MultipleDedication}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/couriers/edit/:courierId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "hr",
                                    "hrEmployment",
                                    "equipmentManager",
                                    "ik",
                                    "agencyIk",
                                    "software",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy"
                                ]}
                                RenderComponent={NewCourier}
                                courierId={props.match.params.courierId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/couriers/courier-requests"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "bm",
                                    "sy",
                                    "ik",
                                    "agency",
                                    "agencyIk"
                                ]}
                                RenderComponent={CourierRequestsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/couriers/:courierId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "hr",
                                    "hrEmployment",
                                    "equipmentManager",
                                    "ik",
                                    "agencyIk",
                                    "seller",
                                    "operationSupport",
                                    "operationImproving",
                                    "software",
                                    "data",
                                    "cUser",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "sOperation",
                                    "sChef",
                                    "fieldManager",
                                    "sales"
                                ]}
                                RenderComponent={CourierDetail}
                                courierId={props.match.params.courierId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/couriers"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "hr",
                                    "hrEmployment",
                                    "equipmentManager",
                                    "ik",
                                    "agencyIk",
                                    "seller",
                                    "operationSupport",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "cUser",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "sOperation",
                                    "sChef",
                                    "fieldManager",
                                    "sales"
                                ]}
                                RenderComponent={CourierPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/available-couriers"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm",
                                    "sy",
                                    "sOperation",
                                    "sChef"
                                ]}
                                RenderComponent={AvailableCouriers}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/orders/:deliveryId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "hrEmployment",
                                    "ik",
                                    "agencyIk",
                                    "seller",
                                    "operationSupport",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "fieldManager",
                                    "data",
                                    "operationImproving",
                                    "oUser",
                                    "sOperation",
                                    "sChef",
                                    "software",
                                    "marketing",
                                    "finance"
                                ]}
                                RenderComponent={OrderDetail}
                                deliveryId={props.match.params.deliveryId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/orders"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "hrEmployment",
                                    "ik",
                                    "agencyIk",
                                    "seller",
                                    "operationSupport",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "sOperation",
                                    "sChef",
                                    "fieldManager",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "marketing",
                                    "sales"
                                ]}
                                RenderComponent={OrderPage}
                                {...props}
                            />
                        )}
                    />
                    {/* <Route
                        path="/transfers/new-transfer-center"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm", "agency",
                                    "sy"
                                ]}
                                RenderComponent={NewTransferCenter}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/transfer-center"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm", "agency",
                                    "sy"
                                ]}
                                RenderComponent={TransferCenterList}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/undelivered-shipments"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm", "agency",
                                    "sy"
                                ]}
                                RenderComponent={UndeliveredShipments}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/transfer-activities"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm", "agency",
                                    "sy"
                                ]}
                                RenderComponent={TransferActivities}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/shipment-activities/:shipmentId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm", "agency",
                                    "sy"
                                ]}
                                RenderComponent={ShipmentActivitiesDetail}
                                shipmentId={props.match.params.shipmentId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/active-transfers"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm", "agency",
                                    "sy"
                                ]}
                                RenderComponent={ActiveTransfers}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/transfer-grouping"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm", "agency",
                                    "sy"
                                ]}
                                RenderComponent={TransferGrouping}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/calculated-transfer"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm", "agency",
                                    "sy"
                                ]}
                                RenderComponent={CalculatedTransfer}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/transfer-rotate"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm", "agency",
                                    "sy"
                                ]}
                                RenderComponent={PlanningDraft}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/dashboard"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm", "agency",
                                    "sy"
                                ]}
                                RenderComponent={TransferDashboard}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "operationSupport",
                                    "oUser",
                                    "bm", "agency",
                                    "sy"
                                ]}
                                RenderComponent={TransferPage}
                                {...props}
                            />
                        )}
                    /> */}
                    <Route
                        path="/equipments/requests"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "bm", "equipmentManager", "sy"]}
                                RenderComponent={EquipmentRequests}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/equipments/courier-equipments"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "equipmentManager",
                                    "sy",
                                    "bm",
                                    "ik"
                                ]}
                                RenderComponent={CourierEquipments}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/equipments/types"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "equipmentManager"
                                ]}
                                RenderComponent={EquipmentsTypes}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/equipments"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "equipmentManager"
                                ]}
                                RenderComponent={Equipments}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/users/new"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "agency"
                                ]}
                                RenderComponent={NewUser}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/users/authorization-management"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software"
                                ]}
                                RenderComponent={AuthorizationManagement}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/users/operation-organization"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software"
                                ]}
                                RenderComponent={OperationOrganization}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/users/edit/:userId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "agency"
                                ]}
                                RenderComponent={NewUser}
                                {...props}
                                userId={props.match.params.userId}
                            />
                        )}
                    />
                    <Route
                        path="/users/authorization/:userId"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin"]}
                                RenderComponent={UserAuthorization}
                                {...props}
                                userId={props.match.params.userId}
                            />
                        )}
                    />
                    <Route
                        path="/users/:userId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "agency",
                                    ...USER_TICKET_VIEWER_ROLES
                                ]}
                                RenderComponent={UserDetail}
                                {...props}
                                userId={props.match.params.userId}
                            />
                        )}
                    />
                    <Route
                        path="/users"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "agency",
                                    ...USER_TICKET_VIEWER_ROLES
                                ]}
                                RenderComponent={UserPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/profile"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "cUser",
                                    "hr",
                                    "hrEmployment",
                                    "equipmentManager",
                                    "ik",
                                    "agencyIk",
                                    "seller",
                                    "operationSupport",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "sOperation",
                                    "sChef",
                                    "fieldManager",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "marketing",
                                    "sales"
                                ]}
                                RenderComponent={ProfilePage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/password-reset"
                        render={props => (
                            <NewPasswordRedesign token={props.match.params.token} {...props} />
                        )}
                    />
                    <Route
                        path="/third-party-request/new/:deliveryId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "cUser"
                                ]}
                                RenderComponent={NewRequest}
                                deliveryId={props.match.params.deliveryId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/third-party-request/new/"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "cUser",
                                    "oUser",
                                    "bm",
                                    "sy"
                                ]}
                                RenderComponent={NewRequest}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/create-delivery-request"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "cUser",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "sOperation",
                                    "sChef"
                                ]}
                                RenderComponent={CreateDeliveryRequest}
                                {...props}
                            />
                        )}
                    />
                    {/* <Route
                        path="/shift-requests"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "hr",
                                    "ik",
                                    "agencyIk",
                                    "sales"
                                ]}
                                RenderComponent={CourierSupportRequestsPage}
                                {...props}
                            />
                        )}
                    /> */}
                    <Route
                        path="/credit-logs/cari-list/:subCompanyId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "oUser",
                                    "bm",
                                    "sy",
                                    "cUser",
                                    "finance"
                                ]}
                                RenderComponent={CariListDetail}
                                subCompanyId={props.match.params.subCompanyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/credit-logs/cari-list"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "oUser",
                                    "bm",
                                    "sy",
                                    "cUser",
                                    "finance"
                                ]}
                                RenderComponent={CariList}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/payments"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "bm",
                                    "agency",
                                    "operationSupport"
                                ]}
                                permissionKeys={[PAYMENTS_PERMISSION_KEYS.viewPage]}
                                RenderComponent={PaymentsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/credit-logs"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "cUser",
                                    "finance",
                                    "equipmentManager"
                                ]}
                                RenderComponent={CreditLogTable}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/subcompany-invoices"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "finance"]}
                                RenderComponent={SubCompanyInvoiceManagement}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/cash-on-delivery/past-periods"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "finance"
                                ]}
                                RenderComponent={BackOfficeCODPastPeriodsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/cash-on-delivery/matchable-invoices"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "finance"
                                ]}
                                RenderComponent={BackofficeMatchableInvoicesPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/cash-on-delivery/subCompanies"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy"
                                ]}
                                RenderComponent={SubcompanyCodPaymentListPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/cash-on-delivery/courier-terminals"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm",
                                    "sy",
                                    "sOperation",
                                    "sChef",
                                    "finance"
                                ]}
                                RenderComponent={CourierTerminalListPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/cash-on-delivery/cash-on-delivery-summary"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm",
                                    "sy",
                                    "sOperation",
                                    "sChef",
                                    "finance"
                                ]}
                                RenderComponent={BackofficePaymentSummaryPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/cash-on-delivery"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "oUser",
                                    "bm",
                                    "sy",
                                    "finance"
                                ]}
                                RenderComponent={BackofficeCashOnDeliveryPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/packet-objection"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "cUser"
                                ]}
                                RenderComponent={ObjectionPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/reports/courierStatistics"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "fieldManager",
                                    "sOperation",
                                    "sChef"
                                ]}
                                RenderComponent={CourierStatisticsReportPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/reports/order"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "sOperation",
                                    "sChef",
                                    "fieldManager"
                                ]}
                                RenderComponent={OrderReportPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/reports/shift-score/objections"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "fieldManager",
                                    "operationSupport"
                                ]}
                                RenderComponent={Objections}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/reports/shift-score"
                        render={props => (
                            <AuthChecker
                                // Panel kullanıcıları /shift-management'a taşındı; bu ekran
                                // yalnız firma kullanıcısının anasayfası olarak kaldı.
                                roles={["cUser"]}
                                RenderComponent={ShiftScore}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/reports/shift-compliance"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "fieldManager",
                                    "sOperation",
                                    "sChef"
                                ]}
                                RenderComponent={ShiftCompliance}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/reports/metabase/couriers"
                        render={props => (
                            <AuthChecker
                                roles={metabaseReportRoles}
                                RenderComponent={MetabaseReportsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/reports"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "hr",
                                    "operationSupport",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "ik",
                                    "agencyIk",
                                    "equipmentManager",
                                    "sOperation",
                                    "sChef",
                                    "fieldManager",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "marketing",
                                    "cUser",
                                    "finance",
                                    "hr"
                                ]}
                                RenderComponent={ReportsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/appconfig"
                        render={props => (
                            <AuthChecker
                                roles={["superadmin"]}
                                RenderComponent={AppConfigPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/statistics"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "cUser",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "sOperation",
                                    "sChef",
                                    "fieldManager"
                                ]}
                                RenderComponent={Statistics}
                                {...props}
                            />
                        )}
                    />
                    {/* <Route
                        path="/heatmap"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm", "agency",
                                    "sy",
                                    "fieldManager"
                                ]}
                                RenderComponent={Heatmap}
                                {...props}
                            />
                        )}
                    /> */}
                    <Route
                        path="/shift-management/snapshot"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "fieldManager",
                                    "seller"
                                ]}
                                RenderComponent={ShiftManagementSnapshot}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/shift-management/day-off"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "fieldManager",
                                    "seller"
                                ]}
                                RenderComponent={DayOff}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/shift-management"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "fieldManager",
                                    "sOperation",
                                    "sChef",
                                    "seller"
                                ]}
                                RenderComponent={ShiftManagement}
                                {...props}
                            />
                        )}
                    />
                    {/* <Route
                        path="/shift-suggestion"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "bm", "agency",
                                    "sy",
                                    "sOperation"
                                ]}
                                RenderComponent={ShiftSuggestion}
                                {...props}
                            />
                        )}
                    /> */}
                    <Route
                        path="/payment-management"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "finance"]}
                                RenderComponent={PaymentManagement}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/contract-management"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport"]}
                                RenderComponent={ContractTemplateManagement}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/edit-supplier/:supplierId"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport"]}
                                RenderComponent={EditSupplierPage}
                                supplierId={props.match.params.supplierId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/edit-integrator/:integratorId"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport"]}
                                RenderComponent={EditIntegratorPage}
                                integratorId={props.match.params.integratorId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/new-supplier/:companyId"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport"]}
                                RenderComponent={EditSupplierPage}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/new-integrator"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport"]}
                                RenderComponent={EditIntegratorPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/new"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "bm", "sy"]}
                                RenderComponent={NewPool}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/shift-management"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "oUser",
                                    "bm",
                                    "sy",
                                    "sOperation",
                                    "sChef"
                                ]}
                                RenderComponent={PoolShiftManagement}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/intensities"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "sOperation",
                                    "sChef"
                                ]}
                                RenderComponent={PoolIntensities}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/intensity/callbacks"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "oUser",
                                    "bm",
                                    "sy",
                                    "sOperation",
                                    "sChef"
                                ]}
                                RenderComponent={PoolIntensityCallbacks}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/courier-shifts"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "sOperation",
                                    "sChef"
                                ]}
                                RenderComponent={PoolCourierShifts}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/shift-cancel-requests"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "bm", "sy"]}
                                RenderComponent={PoolCancelRequests}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/courier-bonus-campaigns"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "bm", "sy"]}
                                RenderComponent={PoolCourierBonusCampaigns}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/edit"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "bm", "agency", "sy"]}
                                RenderComponent={EditPool}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/authorized-users"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "bm", "sy"]}
                                RenderComponent={EditPoolUsers}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/payment-contracts"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "bm", "sy"]}
                                RenderComponent={PoolPaymentContracts}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/support-pool-settings"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "bm", "sy"]}
                                RenderComponent={PoolSupporter}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/merge-options"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "bm", "sy"]}
                                RenderComponent={PoolMergeOptions}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/daily-forecasts"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "bm", "sy"]}
                                RenderComponent={DailyPoolForecasts}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/daily-slots"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "oUser",
                                    "bm",
                                    "sy",
                                    "sOperation",
                                    "sChef"
                                ]}
                                RenderComponent={DailyPoolSlots}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "sOperation",
                                    "sChef"
                                ]}
                                RenderComponent={PoolDetail}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "sOperation",
                                    "sChef"
                                ]}
                                RenderComponent={Pools}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/payments"
                        render={props => (
                            <AuthChecker roles={["cUser"]} RenderComponent={Payments} {...props} />
                        )}
                    />
                    <Route
                        path="/wallet/couriers"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "operationSupport",
                                    "finance",
                                    "equipmentManager"
                                ]}
                                RenderComponent={CourierWalletListPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/wallet/inactive-couriers"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "oUser",
                                    "bm",
                                    "agency",
                                    "sy",
                                    "operationSupport",
                                    "finance",
                                    "equipmentManager"
                                ]}
                                RenderComponent={InactiveCourierWalletListPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/ticket-management"
                        render={props => (
                            <AuthChecker
                                roles={TICKET_BACKOFFICE_ROLES}
                                RenderComponent={TicketManagementPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/applications"
                        render={props => (
                            <AuthChecker
                                roles={APPLICATION_ROLES}
                                RenderComponent={ApplicationsPage}
                                {...props}
                            />
                        )}
                    />
                    {Object.values(APPLICATION_TYPES).map(type => (
                        <Route
                            key={type}
                            exact
                            path={`/applications/${type}/:applicationId`}
                            render={props => (
                                <AuthChecker
                                    roles={APPLICATION_ROLES}
                                    RenderComponent={ApplicationDetailPage}
                                    {...props}
                                    type={type}
                                    applicationId={props.match.params.applicationId}
                                />
                            )}
                        />
                    ))}
                    <Route
                        exact
                        path="/ticket-types"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "software"]}
                                RenderComponent={TicketTypesPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/adjustments/adjustment-types"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "finance", "equipmentManager"]}
                                RenderComponent={AdjustmentTypesPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/adjustments/courier-adjustments"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "finance", "equipmentManager"]}
                                RenderComponent={CourierAdjustmentsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/wallet/courier-financial-uploads"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "bm",
                                    "sy",
                                    "cUser",
                                    "finance",
                                    "equipmentManager"
                                ]}
                                RenderComponent={WalletCourierFinancialUploads}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/kapida-odeme/gecmis-donemler"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={MerchantCODPastPeriodsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/kapida-odeme"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerCashOnDeliveryPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/siparislerim/:deliveryId"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerOrderDetailPage}
                                deliveryId={props.match.params.deliveryId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/siparislerim"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerOrdersPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/muhasebe"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerAccountingPage}
                                {...props}
                            />
                        )}
                    />{" "}
                    <Route
                        path="/musteri/raporlar"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerReportsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/vardiyalar"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerShiftsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/taleplerim"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerRequestsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/talep-yonetimi"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerTicketsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/istatistikler"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerStatisticsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/sozlesme"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerContractPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/manuel-gonderi-olustur"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerManualDeliveryPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/entegrasyonlar"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerIntegrationsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/kurye-gunluk-islemleri"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerCourierDailyOperationsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/duyurular"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerHomePage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/hesabim"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerProfilePage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/harita"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerHeatMap}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerHomePage}
                                {...props}
                            />
                        )}
                    />
                    <Route path="*" render={props => <AuthChecker roles={[]} {...props} />} />
                </Switch>
            </Theme>
        </BrowserRouter>
    ));
});

export default Routes;
